module.exports = __webpack_public_path__ + "img/sam3.3f84e8d0.jpg";